<p>
  <button (click)="toggleImporter()" *ngIf="!addImporter" class="mat-raised-button mat-primary" color="primary">Add Importer</button>
  <button (click)="toggleImporter()" *ngIf="addImporter" class="mat-raised-button mat-primary" color="primary">Hide Importer</button>
</p>

<ng-container *ngIf="addImporter">
  <div *ifPrivilege="{name: 'read', value: 'imports'}" class="split-wrapper">
    <div class="split">
      <data-table
        (custom)="onCustomImportType($event)"
        [columns]="columnsImportType"
        [dataProvider]="importTypeService"
        [title]="'Filter ImportType'"
        [validator]="{ validate:'_id',  target: this.selectedImportType }"
        alternative_icon="clear"
        icon="keyboard_arrow_right"
        [table_id]="'importType'"
      ></data-table>
    </div>

    <div class="split">
      <data-table
        (custom)="assignImport($event)"
        [columns]="columnsImport"
        [dataProviderParams]="paramsImport"
        [dataProvider]="importService"
        [title]="'Choose Imports'"
        [validator]="{ validate:'_id',  target: this.composition.importIds }"
        alternative_icon="remove_circle"
        icon="add_circle"
        table_id="imports"
      ></data-table>
    </div>
  </div>
</ng-container>


<div class="assigned">
  <h3>Assigned</h3>
  <data-table
    #assignedImportsTable
    (detail)="onDetailImporter($event)"
    (remove)="removeAssignedImport($event)"
    [columns]="columnsAssignedImports"
    [dataProvider]="assignedImportsProvider">
  </data-table>
</div>
